module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 3-f8a111fc031986ea291399b86ed25bd2.jpg";